import {ItemCatalogue2Desc} from 'api-types/ffconnect-hal';
import {toDecimalFr} from '../utils/toDecimalFr';
import {formatQuantiteAvecCoefficient} from '../utils/formatQuantiteAvecCoefficient';
import {State} from '@synako/halitrek';
import {useTranslation} from 'react-i18next';

export const useBoutonAchatQuantiteDisplay = ({
  quantite,
  commandeEnColis,
  itemCatalogue,
}: {
  quantite: number;
  commandeEnColis: boolean;
  itemCatalogue: State<ItemCatalogue2Desc>;
}) => {
  const {
    quantite_colis_entier,
    coefficient_commande_client_vers_facturation,
    unite_de_commande_client,
    unite_de_facturation,
  } = itemCatalogue.data;
  const {t} = useTranslation();

  const quantite_text = !commandeEnColis ? (
    formatQuantiteAvecCoefficient({
      quantite,
      uniteCommande: unite_de_commande_client,
      uniteFacturation: unite_de_facturation,
      coefficientCommande: coefficient_commande_client_vers_facturation ?? 1,
      formatUnite: (unite: string, count: number) =>
        t(`unite.${unite}`, {count}),
    })
  ) : (
    <>
      {t('global.colis', {
        // Permet de faire le calcul un peu en avance de phase par rapport à ce qui va être fait en back par le switch
        count:
          quantite < (quantite_colis_entier ?? 1)
            ? 1
            : Math.round(quantite / (quantite_colis_entier ?? 1)),
      })}{' '}
      ({toDecimalFr(quantite, 0, 3)}&nbsp;
      {t(`unite.${unite_de_commande_client}`, {count: quantite})})
    </>
  );
  return {quantite_text};
};
